export default {
  apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.activetsl.id/api',
  apiWpUrl: process.env.WP_API_BASE_URL || 'https://tarbiyahsunnahlearning.or.id',
  secureLSSecret: process.env.REACT_APP_SECURE_LS_SECRET || '@ManhajSalaf26120',
};
